import clsx from "clsx";
import React, { FC } from "react";

const GradientBackground: FC<{
  children: React.ReactNode;
  className?: string;
  enabled?: boolean;
  hover?: boolean;
}> = ({ children, className = null, enabled = true, hover = false }) => {
  return (
    <div
      className={clsx(
        enabled && "bg-gradient-to-r from-aqua/50 to-blue/50",
        hover && "hover:bg-gradient-to-r from-aqua/50 to-blue/50",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default GradientBackground;
